export default "__VITE_ASSET__CyxCSLao__"